import "./index.scss";

export const BrandRestrictionsHeader = ({ lastUpdate }) => (
  <div className="brand-restrictions-header">
    <h1>Restricted Gift Card Brands </h1>
    <p>
      Due to redemption restrictions set by individual retailers, GCX does not
      accept any of the following gift card brands to be listed for sale on the
      marketplace. Please check this page frequently as we update this list
      often.
    </p>
    {lastUpdate && (
      <p>
        <strong>Last Update: </strong>
        {lastUpdate}
      </p>
    )}
  </div>
);
